import { combineReducers } from 'redux';
import mergeWith from 'lodash/merge';
import session from './session';
import profile from './profile';
import correspondence from './correspondence';
import listings from './listings';
import folders from './folders';
import activity from './activity';
import search from './search';
import publicportal from './publicportal';
import transaction from './transaction';
import contacts from './contacts';



const defaultEntityState = {
    Activities: {},
    Listings: {},
    //ListingsSearch: {},
    Folders: {},
    activity: {}
};

const entities = (state = defaultEntityState, action) => {
    if (action.response && action.response.entities) {
      return mergeWith({}, state, action.response.entities, (src, dest) => {
        // Deep merge arrays
        if (Array.isArray(src)) {
          return dest;
        }
      });
    }

    return state;
  };

const appReducer = combineReducers({
    entities,
    session,
    profile,
    correspondence,
    listings,
    folders,
    activity,
    search,
    transaction,
    publicportal,
    contacts
});

const rootReducer = (state, action) => {

   return appReducer(state, action);
}


export default rootReducer;